module.exports = __webpack_public_path__ + "img/barrel.2dedbad9.jpg";